var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInvert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.376 20.6804L23.6885 22.2566H11.9609C12.1642 23.6811 12.6733 24.9484 13.4863 26.0564C14.2655 27.1958 15.248 28.0825 16.4336 28.7156C17.6195 29.3804 18.9246 29.7126 20.3477 29.7126C21.8045 29.7126 23.1436 29.3965 24.3633 28.7634C25.091 28.3856 25.7449 27.9156 26.3281 27.3572L28.6543 29.6833C28.029 30.2285 27.3451 30.7145 26.5996 31.1375C24.7022 32.2455 22.5839 32.7995 20.2461 32.7996C17.9759 32.7995 15.9423 32.2455 14.1465 31.1375C12.3171 30.0611 10.8765 28.589 9.82617 26.7214C8.74215 24.8854 8.20026 22.8267 8.2002 20.5476V19.4548H26.6875L25.376 20.6804ZM19.6865 8.19995C22.126 8.2 24.3467 8.73795 26.3457 9.81421C28.3106 10.9221 29.8864 12.4106 31.0723 14.2781C32.2242 16.1458 32.8007 18.2367 32.8008 20.5476C32.8007 22.8268 32.241 24.8854 31.123 26.7214C30.8068 27.2496 30.4577 27.7448 30.0791 28.2097L27.6416 25.7722C28.3123 24.7594 28.7574 23.6103 28.9756 22.324H28.9814L28.9854 22.3054C29.1866 21.3511 29.224 20.3688 29.0947 19.4021H29.082C28.8737 17.8725 28.3518 16.4965 27.5146 15.2761C26.6337 14.0417 25.4974 13.0599 24.1084 12.3318C22.7194 11.6355 21.1942 11.2869 19.5342 11.2869C18.2131 11.2869 16.9252 11.4765 15.6719 11.8562C14.4184 12.2361 13.3675 12.7751 12.5205 13.4714L10.1816 11.1443C11.6046 10.163 13.0968 9.41838 14.6553 8.91187C16.1797 8.43718 17.8573 8.2 19.6865 8.19995Z",
    fill: "url(#paint0_linear_33_1101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_1101",
    x1: 24.0881,
    y1: 32.7996,
    x2: 8.20131,
    y2: -11.4801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInvert);
export default __webpack_public_path__ + "static/media/logo_invert.4cc50dee35f43a7f3266b5461aac19a9.svg";
export { ForwardRef as ReactComponent };